export class RecentlyViewedModel {
    private readonly _ids: number[];

    constructor(public readonly ids: number[]) {
        this._ids = ids;
    }

    public get productIds(): number[] {
        return this._ids;
    }
}